import { render, staticRenderFns } from "./PostPreviewExtended.vue?vue&type=template&id=08c4b82a&scoped=true&"
import script from "./PostPreviewExtended.vue?vue&type=script&lang=js&"
export * from "./PostPreviewExtended.vue?vue&type=script&lang=js&"
import style0 from "./PostPreviewExtended.vue?vue&type=style&index=0&id=08c4b82a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c4b82a",
  null
  
)

export default component.exports